import React from 'react';

const customDatePicker = () => <span className="ccalnd-icon"><i className="fa fa-calendar"></i></span>

export default customDatePicker